{
  "loading": "Cargando proyecto…",
  "load_error_title": "No se pudo cargar el tablero",
  "load_error_message": "Ocurrió un problema al cargar este proyecto. Revisa tu conexión e inténtalo de nuevo.",
  "retry": "Reintentar",
  "private_team_title": "Solo miembros del equipo {dept}",
  "private_project_title": "Solo miembros explícitos pueden ver este proyecto",
  "private_label": "Privado",
  "no_description": "Sin descripción",
  "members_count_title_one": "{n} miembro explícito",
  "members_count_title_other": "{n} miembros explícitos",
  "add_members_title": "Añadir miembros al proyecto",
  "members": "Miembros",
  "ai_summary_title": "Resumen ejecutivo con IA",
  "ai_summary": "Resumen IA",
  "record_meeting_title": "Grabar reunión de este proyecto",
  "record_meeting": "Grabar reunión",
  "confirm_delete_column_title": "¿Eliminar la columna \"{name}\"?",
  "confirm_delete_column_message": "Las tareas de esta columna se moverán a \"{destination}\". Las demás columnas: {remaining}.",
  "confirm_delete_column_action": "Eliminar columna",
  "error_delete_column": "No se pudo eliminar la columna.",
  "confirm_delete_board_title": "¿Eliminar el tablero \"{name}\"?",
  "confirm_delete_board_message": "Se eliminará el tablero con todas sus columnas y tareas. Esta acción no se puede deshacer.",
  "confirm_delete_board_action": "Eliminar tablero",
  "error_delete_board": "No se pudo eliminar el tablero.",
  "linked_section": "Vinculadas",
  "board_menu": {
    "button": "Más",
    "title": "Más acciones del tablero",
    "public_tickets": "Solicitudes públicas",
    "rename": "Cambiar nombre",
    "delete": "Eliminar tablero",
    "schedule": "Duración y responsable",
    "share": "Copiar enlace del tablero"
  },
  "rename": {
    "title": "Cambiar nombre del tablero",
    "label": "Nombre del tablero",
    "placeholder": "Nombre del tablero",
    "save": "Guardar",
    "saving": "Guardando…",
    "error": "No se pudo cambiar el nombre."
  },
  "move": {
    "button": "Mover a equipo",
    "title": "Mover proyecto a otro equipo",
    "description": "Elegí el equipo al que querés mover \"{name}\". Sus secciones y tareas se mueven con él; el departamento y los miembros que no estén en el equipo destino se quitan.",
    "no_teams": "No tenés otros equipos donde seas owner o admin.",
    "error": "No se pudo mover el proyecto.",
    "cancel": "Cancelar",
    "confirm": "Mover",
    "moving": "Moviendo…"
  },
  "import": {
    "button": "Importar",
    "button_title": "Importar tareas desde un Excel de Planner",
    "title": "Importar tareas de Planner",
    "help": "Sube el Excel exportado desde Microsoft Planner (\"Exportar plan a Excel\"). Cada fila se convierte en una tarea y los depósitos en columnas del tablero.",
    "pick_file": "Haz clic para elegir el archivo (.xlsx, .xls o .csv)",
    "cancel": "Cancelar",
    "submit": "Importar",
    "importing": "Importando…",
    "error_generic": "No se pudo importar el archivo.",
    "done_count": "Se importaron {n} tarea(s).",
    "sections_created": "Se crearon {n} columna(s) nueva(s).",
    "skipped": "Se omitieron {n} fila(s) sin nombre.",
    "limit_reached": "Se alcanzó el límite de tareas de tu plan; no se importaron todas.",
    "unmatched": "Asignados no encontrados en el equipo: {names}.",
    "finish": "Listo"
  },
  "report": {
    "button": "Reporte",
    "button_title": "Generar un reporte del proyecto",
    "title": "Reporte del proyecto",
    "description": "Genera un PDF con el estado de las tareas de \"{name}\". Opcionalmente filtra por rango de fechas.",
    "presets": {
      "this_month": "Este mes",
      "last_30": "Últimos 30 días",
      "this_year": "Este año",
      "clear": "Sin filtro"
    },
    "from": "Desde",
    "to": "Hasta",
    "hint": "Si no eliges fechas, se usan los últimos 7 días.",
    "range_error": "La fecha «Desde» no puede ser mayor que «Hasta».",
    "error": "No se pudo generar el reporte.",
    "cancel": "Cancelar",
    "generate": "Generar PDF",
    "generating": "Generando…"
  },
  "error_reorder_columns": "No se pudieron reordenar las columnas.",
  "filters": {
    "button": "Filtros",
    "title": "Filtrar tareas",
    "active_one": "1 filtro",
    "active_other": "{n} filtros",
    "tags_label": "Por etiqueta",
    "assignees_label": "Por responsable",
    "no_tags": "Este proyecto no tiene tareas con etiquetas.",
    "no_assignees": "Este proyecto no tiene tareas con responsables.",
    "clear": "Limpiar filtros",
    "empty_result": "Ninguna tarea coincide con los filtros."
  },
  "health": {
    "label": "Estado",
    "none": "Sin estado",
    "on_track": "En tiempo",
    "at_risk": "En riesgo",
    "off_track": "Retrasado",
    "panel_title": "Estado del proyecto",
    "body_placeholder": "¿Cómo va el proyecto? (opcional)",
    "publish": "Publicar actualización",
    "publishing": "Publicando…",
    "history_empty": "Aún no hay actualizaciones de estado.",
    "posted": "Estado publicado",
    "badge_title": "Ver y publicar estado del proyecto"
  },
  "pending_tickets_title": "Solicitudes pendientes recibidas por el enlace público",
  "pending_tickets_count": "{n} solicitud | {n} solicitudes",
  "schedule": {
    "title": "Duración y responsable",
    "description": "Define cuánto se estima que dure el proyecto y quién le da seguimiento.",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de fin",
    "invalid_range": "La fecha de fin no puede ser anterior a la de inicio.",
    "duration_days": "{n} día estimado | {n} días estimados",
    "since": "Desde {date}",
    "until": "Hasta {date}",
    "owner": "Responsable directo",
    "owner_none": "Sin responsable",
    "owner_help": "Es el punto de contacto principal y quien da seguimiento al avance.",
    "owner_title": "Responsable: {name}",
    "save": "Guardar",
    "saving": "Guardando…",
    "cancel": "Cancelar",
    "error": "No se pudo guardar la duración y el responsable."
  }
}
